import { CohabitationVM } from 'cohabitation/view-models/list-cohabitation';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCellsCohabitation: HeadCell<CohabitationVM, keyof CohabitationVM>[] = [
  {
    id: 'idCardMunicipality',
    label: 'Id scheda Comune',
  },
  {
    id: 'codeIstat',
    label: 'Codice ISTAT Comune',
  },
  {
    id: 'idANPR',
    label: 'Id ANPR',
  },
  {
    id: 'nameCohabitation',
    label: 'Nome convivenza',
  },
  {
    id: 'address',
    label: 'Indirizzo',
  },
  {
    id: 'parenthood',
    label: 'Parentela',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
